import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=484cc500&scoped=true&"
import script from "./TextField.vue?vue&type=script&lang=ts&"
export * from "./TextField.vue?vue&type=script&lang=ts&"
import style0 from "./TextField.vue?vue&type=style&index=0&id=484cc500&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484cc500",
  null
  
)

export default component.exports